<script>
import Component from '@/components/Task/Widget/Types/Task'
export default Component
</script>
